import React from 'react';
import './EventServices.css';

const services = [
  {
    title: 'Traducción Simultánea',
    description: 'Equipos y técnicos para traducción en vivo en múltiples idiomas.',
    icon: '🎧',
  },
  {
    title: 'Sonido Profesional',
    description: 'Sonido de alta fidelidad para eventos de todo tipo.',
    icon: '🔊',
  },
  {
    title: 'Proyección HD',
    description: 'Proyección en alta definición con técnicos especializados.',
    icon: '📽️',
  },
  {
    title: 'Pantallas LED',
    description: 'Pantallas LED gigantes para máxima visibilidad.',
    icon: '🖥️',
  },
];

const EventServices = () => {
  return (
    <section className="services-container" style={{ width: '100%', padding: '20px', boxSizing: 'border-box' }}>
        <img src='https://firebasestorage.googleapis.com/v0/b/pichuninuni.appspot.com/o/Maac%2FLogoblanco%20maac%20transparente.png?alt=media&token=6e6f284d-25f7-4143-9258-29542bcfa65c' 
        alt='logo' className='logo' style={{  height: '100px' }}/>  
    <h1 className="title">Audiovisuales</h1>
      <header style={{
  background: 'linear-gradient(to right, #2c3e50, #4ca1af)',
  padding: '60px 20px',
  color: 'white',
  textAlign: 'center'
}}>
  <h1 style={{ fontSize: '3rem' }}>Soluciones Técnicas para Eventos</h1>
  <p style={{ fontSize: '1.2rem' }}>Traducción, sonido, pantallas LED y más</p>
</header>
<br></br>

      <div className="cards">
        {services.map((service, index) => (
          <div className="card" key={index}>
            <div className="icon">{service.icon}</div>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventServices;
